<script>
	import { querystring, push } from 'svelte-spa-router';
	import { onMount } from 'svelte';


	onMount(() => {
		const params = new URLSearchParams($querystring);
		if (params.has("redirect_url")) {
			let redirect_url = params.get("redirect_url");
			redirect_url = atob(redirect_url);
			console.log(redirect_url);
			push(redirect_url);
		}
	});
</script>